import { Divider, Grid } from "@mui/material";
import { numberWithCommas } from "../../../../utils/utility";
import { useTranslation } from "react-i18next";
import { BREAKPOINT, IS_MOBILE, WIDTH } from "../../../../constants/breakpoints";
import { connect } from "react-redux";
import { LocaleContext } from "../../../../routing/LangRouter";
import { useContext, useState } from "react";

//import icons
import { Airplane, Notification } from "iconsax-react";

//import store
import { saveSelectedTicket } from "../../../../store/actions";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";

//import view components
import IntFlightItemDetails from "./int-flight-item-details";
import AvailabiltyModal from "../../availability/availabilty-modal";

function IntFlightItem({ flightItem, handleSelectedTicket, isFull, dispatch }) {
    //general variables
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
    const [isReserveModalOpen, setIsReserveModalOpen] = useState(false);

    //sessionStorage variables
    const intFlightInformation = JSON.parse(sessionStorage.getItem("intFlightInformation"));
    const generalInformation = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const isTwoWay = intFlightInformation?.returnDate;

    //handle touch events on items in mobile size
    const handleFlightDetails = () => {
        if (WIDTH < BREAKPOINT) {
            handleSelectedTicket("departure", flightItem);
        }
    };

    const handleAvailabilityAction = type => {
        sessionStorage.setItem("selectedIntFlight", JSON.stringify(flightItem));

        sessionStorage.setItem(
            "generalInformation",
            JSON.stringify({
                ...generalInformation,
                isAutomaticReserve: true,
            }),
        );

        dispatch(saveSelectedTicket(flightItem));

        if (type === "notification") {
            setIsNotificationModalOpen(true);
        } else if (type === "reserve") {
            setIsReserveModalOpen(true);
        }
    };

    return (
        <>
            <Grid
                className={`flight-item ${isFull ? "full-flight" : ""}`}
                container
                item
                xs={12}
                justifyContent="center"
                alignItems="center"
                onClick={handleFlightDetails}
            >
                <Grid className="flight-item__details" container item xs={12} md={9} rowGap={{ xs: 1.5, md: 3 }} justifyContent="center">
                    <IntFlightItemDetails flightItem={flightItem} details={flightItem?.segments} title={t("departureFlight")} />
                    {!!intFlightInformation?.returnDate || !!flightItem?.return_segments?.lenght ? (
                        <>
                            <Divider width="100%" />
                            <IntFlightItemDetails flightItem={flightItem} details={flightItem?.return_segments} title={t("returnFlight")} />
                        </>
                    ) : null}
                </Grid>

                <Divider sx={{ width: { xs: "90%", md: "0" } }} />

                <Grid
                    className="flight-item__action"
                    container
                    item
                    xs={12}
                    md={3}
                    rowGap={!!intFlightInformation?.returnDate ? 8 : 2}
                    justifyContent={{ xs: "flex-end", md: "center" }}
                    alignItems="stretch"
                >
                    <Grid
                        container
                        item
                        xs={12}
                        md={12}
                        columnGap={1}
                        direction={{ xs: "row", md: "column" }}
                        justifyContent={{ xs: "space-between", md: "center" }}
                        alignItems="center"
                        order={{ xs: 2, md: 1 }}
                    >
                        <span className="flight-item__price-title">{t("ticketPrice")}:</span>
                        <span>
                            <span className="flight-item__price">{numberWithCommas(flightItem?.fares?.total_price)} </span>
                            {t("currency")}
                        </span>
                    </Grid>

                    {!isTwoWay &&
                        flightItem?.capacity !== null &&
                        (flightItem?.capacity === 0 && !IS_MOBILE ? (
                            <Grid container item xs={12} justifyContent="space-evenly">
                                <BaseButton
                                    text={<Notification />}
                                    color="outline"
                                    radius="radius-50"
                                    size="circular"
                                    handleClick={() => handleAvailabilityAction("notification")}
                                />
                                <BaseButton
                                    text={<Airplane />}
                                    color="outline"
                                    radius="radius-50"
                                    size="circular"
                                    handleClick={() => handleAvailabilityAction("reserve")}
                                />
                            </Grid>
                        ) : (
                            <Grid container item xs={12} xl={10} display={{ xs: "none", md: "flex" }} order={{ xs: 3, md: 2 }}>
                                <BaseButton
                                    text={t("General.Details and Purchase")}
                                    color="primary"
                                    size="large"
                                    radius="radius-10"
                                    disabled={flightItem?.capacity === 0 ? true : false}
                                    handleClick={event => {
                                        event.stopPropagation();
                                        handleSelectedTicket("departure", flightItem);
                                    }}
                                />
                            </Grid>
                        ))}

                    <Grid container item xs={12} justifyContent="space-between" order={{ xs: 1, md: 3 }}>
                        <Grid container item xs={5.9}>
                            <BaseButton
                                text={t("visaRouteRules")}
                                color="outline"
                                radius="radius-10"
                                size="medium"
                                handleClick={event => {
                                    event.stopPropagation();
                                    handleSelectedTicket("rules", flightItem);
                                }}
                            />
                        </Grid>
                        <Grid container item xs={5.9}>
                            <BaseButton
                                text={t("baggageRules")}
                                color="outline-secondary"
                                radius="radius-10"
                                size="medium"
                                handleClick={event => {
                                    event.stopPropagation();
                                    handleSelectedTicket("rules", flightItem);
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <AvailabiltyModal
                    flightItem={flightItem}
                    isModalOpen={isNotificationModalOpen}
                    setIsModalOpen={setIsNotificationModalOpen}
                    title={t("General.Notify When Available")}
                    modalType="notification"
                    pageUrl={`/${locale}/flight-availability`}
                />
                <AvailabiltyModal
                    flightItem={flightItem}
                    isModalOpen={isReserveModalOpen}
                    setIsModalOpen={setIsReserveModalOpen}
                    title={t("General.Reserve When Available")}
                    modalType="reserve"
                    pageUrl={`/${locale}/flight-automatic-reserve`}
                />
            </Grid>
        </>
    );
}

export default connect()(IntFlightItem);
